const KEY = "homework_preferred_child";

export function getPreferredChildId() {
  return window.localStorage.getItem(KEY) ?? "";
}

export function savePreferredChildId(childId: string) {
  window.localStorage.setItem(KEY, childId);
}

export function clearPreferredChildId() {
  window.localStorage.removeItem(KEY);
}
